import { useCallback } from 'react'
import BaseIpcRenderer from '@renderer/ipc/BaseIpc.renderer'
import type { StagedActionEditTag, StagedActionView } from '@renderer/overlay/Sidepanel/hooks/use-staged-actions'
import { useEditOptions } from './edit-options-context'
import { ActionTagBadgeCollection } from './badge-collection'

interface EditableLocalFileProps {
  keyName: string
  tags: Array<StagedActionView['tags'][number]>
  editTag: StagedActionEditTag
}

export function EditableLocalFile({ keyName, tags, editTag }: EditableLocalFileProps) {
  const { onUpdate, isUpdating } = useEditOptions()

  const handleClick = useCallback(async () => {
    if (isUpdating) return
    const result = await BaseIpcRenderer.showOpenDialog({
      properties: ['openDirectory'],
    })
    if (result.canceled || result.filePaths.length === 0) return
    onUpdate({ tagEdits: { [keyName]: [result.filePaths[0]] } })
  }, [isUpdating, onUpdate, keyName])

  return (
    <div
      className={`flex flex-wrap gap-2 ${isUpdating ? 'pointer-events-none opacity-50' : 'cursor-pointer'}`}
      onClick={handleClick}
    >
      <ActionTagBadgeCollection keyName={keyName} tags={tags} editable />
    </div>
  )
}
